import { render, staticRenderFns } from "./DetailPenerbitanPersetujuan.vue?vue&type=template&id=32b895ec&"
import script from "./DetailPenerbitanPersetujuan.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanPersetujuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports